<script setup lang="ts">
import { HomeButton } from '@/components/home'
import { useMinesweeperChallenge } from '@/composables/game/challenges'
import MinesweeperChallengeIcon from '@/assets/images/challenges/minesweeper/minesweeper-challenge-button.webp'

withDefaults(defineProps<{
  containerClass?: string
}>(), {
  containerClass: '',
})

const { countdown, isMinesweeperChallengeLive } = useMinesweeperChallenge()
</script>

<template>
  <HomeButton
    v-if="isMinesweeperChallengeLive"
    label="Minesweeper"
    :countdown="{ value: countdown, dangerThreshold: 3600 * 3 }"
    :show-sparkle="true"
    :button-class="containerClass"
  >
    <img
      class="size-full object-cover z-[3]"
      :src="MinesweeperChallengeIcon"
    >
  </HomeButton>
</template>
